
import i18next from "i18next";
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import TableContainer from "./TableContainer";
import DynamicForm from "../Form";

const IconAddListCell = ({ isOpen, toggle, data, modalTitle, preId, addFunction, editFunction, deleteFunction, columnConfig, fields }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" centered={true}>
      <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>
      <ModalBody>
        <DynamicForm
          fields={fields} 
          initialValues={ {}}
          editFunction={addFunction}
          linkList={'/contacts'}
          withoutCancel={true}
          preId={preId}
          preKey={'customerProjId'} // @TODO: demander à Flo à quoi ça correspond
        />

        <TableContainer
          columnConfig={columnConfig}
          filterConfig={[]}
          data={data}
          tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
          pagination="pagination"
          divClassName="table-responsive"
          isBordered={true}
          isPagination={true}
          isGlobalFilter={false}
          buttonClass="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2"
          buttonName="contact"
          prefListName="contact"
          isAddButton={false}
          linkToNew={'/contacts/new'}
          editFunction={editFunction}
          deleteFunction={deleteFunction}
          noCheckbox={true}
          suffixId={1}
          editPopup={true}
          editPopupFields={fields}
        />
      </ModalBody>
      <ModalFooter>
        <Button id="projCloseBtn" color="secondary" type="button" onClick={toggle}>{i18next.t('close')}</Button>
      </ModalFooter>
    </Modal>
  );
};

export default IconAddListCell;
